<template>
  <Card dis-hover>
    <div slot="title">视频管理 ({{ items.length }}条视频)</div>
    <Row :gutter="10" slot="extra">
      <Col>
        <a type="primary" @click="loadData">刷新视频数据</a>
      </Col>
      <Col>
        <a type="primary" @click="open(null)">上传新视频</a>
      </Col>
    </Row>
    <div>
      <Row :gutter="16">
        <Col :xs="12" :sm="8" :md="6" :lg="4" :key="item.id" v-for="item in items" style="margin-top: 16px">
          <div class="video-card">
            <div style="width: 100%;height: 250px;border-radius:10px 10px 0 0;">
              <img :src="item.cover_url"
                   style="width: 100%;height: 250px;object-fit: cover;border-radius:10px 10px 0 0;"/>
            </div>
            <div class="video-title">
              <Tooltip style="width: 100%" :content="item.video_title" placement="bottom">
                <div class="video-main">
                  {{ item.video_title }}
                </div>
              </Tooltip>
              <div class="video-sub">{{ item.visible ? '已上架' : '未上架' }} · {{ item.view_count }}次观看</div>
              <div class="video-publisher">
                <Avatar :src="item.logo"/>
                <div>{{item.publisher}}</div>
              </div>
            </div>
            <div class="video-actions">
              <div>
                <a @click="view(item.url)">查看</a>
              </div>
              <div>
                <a @click="open(item)">编辑</a>
              </div>
              <div>
                <a @click="remove(item.id)">删除</a>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>

    <!--表单部分-->
    <Modal @on-ok="submit" :width="300" v-model="modal.visible"
           :title="modal.primary ? '编辑视频' : '上传新视频'">
      <Form :rules="modal.rules" :model="modal.model" ref="model">
        <FormItem label="视频名称" prop="video_title">
          <Input v-model="modal.model.video_title" placeholder="| 输入视频名称，或上传自动识别视频名称"/>
        </FormItem>
<!--        <FormItem label="排序值" prop="lft">
          <InputNumber type="number" v-model="modal.model.lft" :min="0" :max="1000" :precision="0"></InputNumber>
        </FormItem>-->
        <FormItem label="视频上传" prop="url">
          <Upload
              type="drag"
              accept="video/*"
              :before-upload="handleUpload"
              action="#"
          >
            <div style="padding: 20px 0">
              <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
              <p>点击或将视频拖拽到此区域开始上传</p>
            </div>
          </Upload>
          <Progress v-show="modal.uploading" :percent="modal.percent"/>
          <div>请等待上传完毕后再提交表单</div>
        </FormItem>
        <FormItem label="发布人" prop="publisher">
          <Input v-model="modal.model.publisher" maxlength="10"/>
        </FormItem>
        <FormItem label="LOGO" prop="logo">
          <MtCropper :imgUrl="modal.model.logo" @change="logoChange">
            <Avatar size="large" :src="modal.model.logo" v-if="modal.model.logo"/>
            <Button>上传LOGO</Button>
          </MtCropper>
        </FormItem>
        <FormItem label="发布状态" prop="visible">
          <RadioGroup v-model="modal.model.visible">
            <Radio :label="0">未上架</Radio>
            <Radio :label="1">已上架</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
    </Modal>
  </Card>
</template>

<script>
import common from "@/common/common";
import TcVod from 'vod-js-sdk-v6'
import MtCropper from "@/components/MtCropper";

export default {
  name: "index",
  components: {MtCropper},
  data: () => ({
    uploadUrl: "",

    conditions: {},

    token: "",
    items: [],
    modal: {
      uploading: false,
      percent: 0,
      visible: false,
      primary: null,
      loading: false,
      model: {},
      rules: {
        video_title: [{required: true, message: '请输入'}],
        url: [{required: true, message: '请上传视频'}],
        // lft: [{required: true, message: '请输入排序'}],
        visible: [{required: true, message: '请设置发布状态'}],
        publisher: [{required: true, message: '请填写发布人'}],
        logo: [{required: true, message: '请上传发布人LOGO'}],
      }
    },

    player: {
      visible: false,

    }
  }),
  created() {
    this.token = common.getToken()
    this.loadData()
  },
  methods: {
    view(url){
      window.open(url)
    },
    logoChange(url) {
      this.$set(this.modal.model, 'logo', url)
    },
    handleUpload(file) {
      this.upload(file)
      return false;
    },
    upload(file) {
      const that = this

      function getSignature() {
        return that.axios.get(that.config.urlArray.tVideoCert).then(function (response) {
          return response.data;
        })
      }


      // 通过 import 引入的话，new TcVod(opts) 即可
// new TcVod.default(opts) 是 script 引入 的用法
      const tcVod = new TcVod({
        getSignature: getSignature // 前文中所述的获取上传签名的函数
      })
      const uploader = tcVod.upload({
        mediaFile: file, // 媒体文件（视频或音频或图片），类型为 File
      })
      this.modal.uploading = true
      uploader.on('media_progress', function (info) {
        that.modal.percent = that.modal.percent > Number((info.percent * 100).toFixed(2)) ? that.modal.percent : Number((info.percent * 100).toFixed(2))
        that.modal.percent = that.modal.percent > 99 ? 99 : that.modal.percent;
      })
// 回调结果说明
// type doneResult = {
//   fileId: string,
//   video: {
//     url: string
//   },
//   cover: {
//     url: string
//   }
// }
      uploader.done().then(function ({fileId, video}) {
        that.modal.percent = 100;
        that.$set(that.modal.model, "video_id", fileId)
        that.$set(that.modal.model, "url", "https://" + video.url.replace("http://", ""))
        if (!that.modal.model.video_title) {
          that.$set(that.modal.model, "video_title", file.name.substring(0, file.name.lastIndexOf('.')))
        }
// deal with doneResult
      }).catch(function (err) {
// deal with error
      })

      uploader.start()
    },

    setPath(suffix) {
      // Date
      const date = new Date()
      let nowMonth = date.getMonth() + 1 // 获取当前月份
      let nowDate = date.getDate() // 获取当前是几号

      // 处理
      if (nowMonth >= 1 && nowMonth <= 9) {
        nowMonth = '0' + nowMonth
      }
      if (nowDate >= 0 && nowDate <= 9) {
        nowDate = '0' + nowDate
      }

      // 返回完整的路径
      return '/upload/' + date.getFullYear() + '-' + nowMonth + '-' + nowDate + '/' + date.getFullYear() + nowMonth + nowDate + date.getHours() + date.getMinutes() + date.getSeconds() + Math.round(Math.random() * 100000) + '.' + suffix
    },


    loadData() {
      this.axios.get(this.config.urlArray.tVideoTable, {
        params: {
          ...this.conditions
        }
      }).then(({data}) => {
        this.items = data
      })
    },

    open(item) {
      if (!item) {
        this.modal.primary = null
        this.modal.model = {
          lft: 0,
          visible: 0
        }
      } else {
        this.modal.primary = item.id
        this.modal.model = {...item}
      }
      this.modal.uploading = false
      this.modal.percent = 0
      this.modal.visible = true
    },

    submit() {
      this.$refs.model.validate(v => {
        if (v) {
          let req = !!this.modal.primary ? this.axios.post(this.config.urlArray.tVideoUpdate(this.modal.primary), this.modal.model) : this.axios.post(this.config.urlArray.tVideoCreate, this.modal.model)

          req.then(res => {
            console.log(res)
            this.modal.visible = false
            this.loadData()
          })
        }
      })
    },
    remove(id) {
      this.$Modal.confirm({
        width: "400px",
        title: '提示',
        content: '是否要删除此视频?',
        closable: true,
        cancelText: "取消",
        onOk: () => {
          this.axios.delete(this.config.urlArray.tVideoUpdate(id)).then(res => {
            this.$Message.success("删除成功")
            this.loadData()
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.video-card {
  box-sizing: border-box;
  border: 1px solid #DCDFE6;
  height: 416px;
  border-radius: 10px;

  .video-title {
    height: 116px;
    width: 100%;

    .video-main {
      padding: 3px 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
      height: 30px;
      text-align: center;
      font-weight: bold;
      font-size: 18px;
      color: #303133;
    }

    .video-sub {
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #909399;
    }

    .video-publisher{
      height: 60px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
    }
  }

  .video-actions {
    border-radius: 0 0 10px 10px;
    height: 50px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    background: #DCDFE6;

    div {
      width: 100%;
      text-align: center;

      a {
        color: #606266;

        transition: color .5s;

        &:hover {
          color: #409eff;
        }
      }
    }

    div + div {
      border-left: 1px solid #606266;
    }

  }
}
</style>